import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';
import { FaLinkedin, FaTwitter, FaGithub } from 'react-icons/fa';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const executives = [
    { name: 'Mr. Kennedy Oyoo', title: 'CEO & Founder', social: { linkedin: '#', twitter: '#', github: '#' } },
    { name: 'Ms. Jane Doe', title: 'COO', social: { linkedin: '#', twitter: '#', github: '#' } },
    { name: 'Dr. John Smith', title: 'CTO', social: { linkedin: '#', twitter: '#', github: '#' } },
    { name: 'Dr. Alice Johnson', title: 'CFO', social: { linkedin: '#', twitter: '#', github: '#' } },
];

const staff = [
    { name: 'Mr. Michael Brown', title: 'AI Engineer', social: { linkedin: '#', twitter: '#', github: '#' } },
    { name: 'Ms. Sarah Wilson', title: 'Cybersecurity Specialist', social: { linkedin: '#', twitter: '#', github: '#' } },
    { name: 'Mr. David Lee', title: 'Data Scientist', social: { linkedin: '#', twitter: '#', github: '#' } },
    { name: 'Ms. Emily Davis', title: 'Software Developer', social: { linkedin: '#', twitter: '#', github: '#' } },
];

const renderCard = (member) => (
    <Card
        hoverable
        style={{
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
            background: 'linear-gradient(135deg, #ffffff, #f0fafa)',
            padding: '24px',
            textAlign: 'center',
            height: '260px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease',
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-10px)';
            e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
            e.currentTarget.style.background = 'linear-gradient(135deg, #f0fafa, #e6fffb)';
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
            e.currentTarget.style.background = 'linear-gradient(135deg, #ffffff, #f0fafa)';
        }}
    >
        <div>
            <Title level={4} style={{ color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>
                {member.name}
            </Title>
            <Paragraph style={{ color: '#595959', fontSize: '14px', fontWeight: '500', marginBottom: '16px' }}>
                {member.title}
            </Paragraph>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={24} style={{ color: '#13c2c2', transition: 'color 0.3s ease' }} 
                    onMouseEnter={(e) => e.currentTarget.style.color = '#08979c'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#13c2c2'} />
            </a>
            <a href={member.social.twitter} target="_blank" rel="noopener noreferrer">
                <FaTwitter size={24} style={{ color: '#fa8c16', transition: 'color 0.3s ease' }} 
                    onMouseEnter={(e) => e.currentTarget.style.color = '#d46b08'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#fa8c16'} />
            </a>
            <a href={member.social.github} target="_blank" rel="noopener noreferrer">
                <FaGithub size={24} style={{ color: '#13c2c2', transition: 'color 0.3s ease' }} 
                    onMouseEnter={(e) => e.currentTarget.style.color = '#08979c'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#13c2c2'} />
            </a>
        </div>
    </Card>
);

function JectHubTeam() {
    return (
        <Layout>
            <Content style={{ padding: '60px', background: 'linear-gradient(135deg, #e6fffb, #fff7e6)', minHeight: '100vh' }}>
                <Title level={2} style={{ fontSize: '20px', color: '#13c2c2', textAlign: 'center', fontWeight: '700', marginBottom: '48px' }}>
                    Meet the JectHub Team
                </Title>

                <Title level={3} style={{ fontSize: '18px', color: '#1a1a1a', marginBottom: '24px', textAlign: 'center' }}>
                    Executive Team
                </Title>
                <Row gutter={[24, 24]} justify="center">
                    {executives.map((member, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            {renderCard(member)}
                        </Col>
                    ))}
                </Row>

                <hr style={{ border: 'none', borderTop: '2px solid #d9d9d9', margin: '40px 0' }} />

                <Title level={3} style={{ fontSize: '22px', color: '#1a1a1a', marginBottom: '24px', textAlign: 'center' }}>
                    Staff Team
                </Title>
                <Row gutter={[24, 24]} justify="center">
                    {staff.map((member, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            {renderCard(member)}
                        </Col>
                    ))}
                </Row>

                {/* Custom CSS */}
                <style jsx global>{`
                    .ant-card {
                        animation: fadeIn 0.5s ease-in-out;
                    }
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(15px); }
                        100% { opacity: 1; transform: translateY(0); }
                    }
                `}</style>
            </Content>
        </Layout>
    );
}

export default JectHubTeam;